import { IAssignee } from "@gtmhub/assignees";
import { IComponentOptions } from "angular";

export class SuggestionsDropdownCtrl {
  // ---- Bindings ---- //
  public selectedSuggestion: IAssignee;
  public suggestions: IAssignee[];
  public searchTerm: string;
  public onSelect: (args: { choice: IAssignee }) => void;
}

export const SuggestionsDropdownComponent: IComponentOptions = {
  controller: SuggestionsDropdownCtrl,
  templateUrl: require("./suggestions-dropdown.jade"),
  bindings: {
    selectedSuggestion: "<",
    suggestions: "<",
    searchTerm: "<",
    onSelect: "&",
  },
};
